import React from "react";
import { cn } from "@gettactic/helpers";

export interface AIRainbowWrapperProps {
  className?: string;
}

export const AIRainbowWrapper: React.FC<
  React.PropsWithChildren<AIRainbowWrapperProps>
> = ({ children, className }) => {
  return (
    <div
      className={cn(
        "relative rounded-2xl bg-gradient-to-r from-[#4C83E4] to-[#A755DA] p-[3px] shadow-2xl",
        className
      )}
    >
      {children}
    </div>
  );
};
